module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp2_6005.0edbb885.png";